import Notifications from "./Notifications";
import { instance } from "./instance";

// This is your plugin object. It can be exported to be used anywhere.
const Notify = {
  // The install method is all that needs to exist on the plugin object.
  // It takes the global Vue object as well as user-defined options.
  install(Vue) {
    if (this.installed) {
      return;
    }

    this.installed = true;

    Vue.component("notifications", Notifications);

    Vue.prototype.$notification = this.notification = (text, options) => {
      instance.$emit("open", text, options);
    };
  }
};

export default Notify;
